import React from 'react';
import { useIsClient } from '@fiverr-private/hooks';
import HeroBannerGerman from '../../../apps/logged_out_homepage_localized/components/HeroBannerGerman';
import SubcategoryCarousel from '../../../apps/logged_out_homepage/components/SubcategoryCarousel';
import FrequentlyAskedQuestions from '../../../apps/logged_out_homepage_localized/components/FrequentlyAskedQuestions';
import Categories from '../../../apps/logged_out_homepage/components/Categories';
import EntryWrapper from '../../../apps/logged_out_homepage_localized/components/EntryWrapper';
import TopPriorities from '../../../apps/logged_out_homepage_localized/components/TopPriorities';
import { getSubCategories } from '../../../apps/logged_out_homepage/components/SubcategoryCarousel/config';
import { shouldLoadPersonalizedSection } from '../../../apps/logged_out_homepage_localized/components/PersonalizedSectionWrapper/shouldLoad';
import TrustBanner from '../../../apps/logged_out_homepage_localized/components/TrustBanner';
import PersonalizedSectionWrapper from '../../../apps/logged_out_homepage_localized/components/PersonalizedSectionWrapper';
import Freelancers from '../../../apps/logged_out_homepage/components/Freelancers';
import HowFiverrWorksVideo from '../../../apps/logged_out_homepage_localized/components/HowFiverrWorksVideo';
import QualityExpertsBanner from '../../../apps/logged_out_homepage_localized/components/QualityExpertsBanner';
import KnowledgeHub from '../../../apps/logged_out_homepage_localized/components/KnowledgeHub';
import ProBanner from '../../../apps/logged_out_homepage/components/ProBannerSection';

interface LoggedOutHomepageClientProps {
    userWasLoggedIn?: boolean;
}

const LoggedOutHomepageClient = ({ userWasLoggedIn }: LoggedOutHomepageClientProps) => {
    const isClient = useIsClient();
    const subCategories = getSubCategories();

    const shouldLoad = isClient && shouldLoadPersonalizedSection({ userWasLoggedIn });

    return (
        <EntryWrapper removeBottomSpace>
            <HeroBannerGerman />
            <Categories />
            {shouldLoad && <PersonalizedSectionWrapper />}
            <SubcategoryCarousel subCategories={subCategories} />
            <HowFiverrWorksVideo />
            <TrustBanner />
            <ProBanner />
            <Freelancers />
            <KnowledgeHub />
            <FrequentlyAskedQuestions />
            <QualityExpertsBanner />
            <TopPriorities />
        </EntryWrapper>
    );
};

export default LoggedOutHomepageClient;
